import { GenericHeader, SearchBar } from 'components';
import ListComp from 'components/ListComp';
import React from 'react';
import { Student } from 'services';
import { Results } from './components';
import { curriculum_manager } from 'utils/constants';
import { useSelector } from 'react-redux';

const UserMasteryList = props => {
  const model = useSelector(state => state.models.student);

  const Head = props => {
    let { handleCreateOpen, ...rest } = props; // eslint-disable-line
    return (
      <GenericHeader header="All User Masteries" subheader="User Mastery Management" {...rest} />
    );
  }

  return (
    <ListComp
      listing={Student.mastery}
      title="User Masteries"
      name="user_masteries"
      searchable
      SearchBar={SearchBar}
      Header={Head}
      Results={Results}
      roles={[curriculum_manager]}
      params={{ student_id: model.id }}
      filters={{ limit: 10, offset: 0, count: 0, search: "", type: "" }}
    />
  );
};

export default UserMasteryList;
